export const CONTENT_GUARD_PAGE = 'page';
export const CONTENT_GUARD_REACT_ELEMENT = 'react element';
